module.exports = __webpack_public_path__ + "img/settings.37f339d1.png";